import React, { useState } from "react";
import Tour from "reactour";
import { Grid } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import { makeStyles } from "@material-ui/core";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import UtilityButton from "./components/UtilityButton";
import { CalculatorContext } from "../../../../app";
import EditableInput from "./components/EditableInput.js";
import { formatter } from "../../../../../common/number-format";
import { UTILITYICONS } from "../../../../../assets/utility-icons";
import { sumAverageStatement } from "../../../../sumAverageStatement";
import { COLORS } from '../../../../../styles/constants';
import "./tablestyle.css";

const useStyles = makeStyles({
  root: {
  },
  tableContainer: {
    borderRadius: "2px",
    overflowX: "visible",
    height: "auto",
    '@media print': {
      border: '2px solid #e1e7ec',
    }
  },
  disabledColumn: {
    height: "100%",
    margin: "0",
    width: "100%",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    backgroundColor: "#F8F9FA",
    position: "absolute",
    opacity: "0.6",
    zIndex: "1",
  },
  tour: {
    background: "#FFF",
    boxShadow: "0px 18px 32px rgba(0, 0, 0, 0.15)",
    borderRadius: "5px",
    color: "#212934",
    fontFamily: "Source Sans Pro",
    fontSize: "18px",
    lineHeight: "28px",
    padding: "32px",
    '& .reactour__dot': {
      height: '10px',
      width: '10px',
      margin: '4px 6px',
      border: `1px solid ${COLORS.SHADE_500}`,
      backgroundColor: COLORS.SHADE_500,
      '&.reactour__dot--is-active': {
        transform: 'scale(1)',
        border: 'none',
      }
    },
    '& .reactour__close': {
      width: '16px',
      height: '16px',
      color: COLORS.DARKGREY,
      top: '32px',
      right: '32px',
    },
    '&.reactour__helper': {
      padding: '32px 60px 32px 40px',
    },
    '& button[data-tour-elem="right-arrow"], & button[data-tour-elem="left-arrow"]': {
      transform: 'scale(1.4)',
      height: '15px',
      color: COLORS.DARKGREY,
      '&:disabled': {
        color: COLORS.SHADE_300,
      }
    }
  },
});

const utilityIconArray = [
  UTILITYICONS.WATERICON,
  UTILITYICONS.FIREICON,
  UTILITYICONS.BINICON,
  UTILITYICONS.FLOODICON,
];

const steps = [
  {
    selector: '[data-tut="first-selector"]',
    content:
      "Enable or disable utilities you want to calculate. Enter their bill values.",
    position: "bottom",
    style: { width: "206px" },
  },
  {
    selector: '[data-tut="second-selector"]',
    content: "Adjust the number of units with certain tenant occupancy",
    style: { width: "220px" },
  },
  {
    selector: '[data-tut="third-selector"]',
    content:
      "Common Area Deduction (CAD) generally increase the amount of the bill that owners will absorb. As you add amenities, you will see the common area deduction increase.",
    position: "bottom",
  },
  {
    selector: '[data-tut="fourth-selector"]',
    content:
      "Livable requires a minimum 5% goodwill deduction, which can offset unreported leaks and occupancy, but also sends the message that you are working together towards a common goal.",
    position: "bottom",
  },
  {
    selector: '[data-tut="fifth-selector"]',
    content: "Adjust your setup to see your recovery potential. Happy savings!",
    position: "bottom",
  },
];

export default function CalculatorTableMain(props) {
  const [isTourOpen, setIsTourOpen] = useState(true);

  const { tenants, updateTenant } = React.useContext(CalculatorContext);
  const { utilities, updateUtilities, updateUtilityCalculations } =
    React.useContext(CalculatorContext);

  const averageStatement = sumAverageStatement(utilities);

  const classes = useStyles();

  // const numberOfUnits = (tenantsArray) => {
  //   let sum = 0;
  //   for (let index = 0; index < tenantsArray.length; index++) {
  //     const eachUnit = parseInt(tenantsArray[index]);
  //     sum = sum + eachUnit;
  //   }
  //   return sum;
  // };
  let disableBody = (target) => disableBodyScroll(target);
  let enableBody = (target) => enableBodyScroll(target);

  return (
    <Grid container className={classes.root} justify="center">
      <Tour
        disableFocusLock={true}
        accentColor="linear-gradient(116.22deg, #009299 16.5%, #00B488 83.5%)"
        showNumber={false}
        className={classes.tour}
        steps={steps}
        isOpen={props.isTourOpen}
        onRequestClose={() => props.handleTourClose()}
        onAfterOpen={disableBody}
        onBeforeClose={enableBody}
        rounded={5}
        startAt={0}
      />

      <TableContainer className={classes.tableContainer}>
        <div className="main-table-row">
          <div className="grid-column grid-column-headers">
            <div className="grid-item header cell dark estimated-amount">
              <div>Bill total value</div>
               <div
                data-tut="first-selector"
                style={{
                  width: "720px",
                  height: "120px",
                  position: "absolute",
                  marginTop: "-43px",
                  marginLeft: "348px",
                }}
              ></div>
            </div>
            <div
              data-tut="second-selector"
              style={{
                width: "335px",
                height: "244px",
                position: "absolute",
                marginLeft: "10px",
                marginTop: "97px",
              }}
            ></div>
            {tenants.map((tenant, index) => (
              <div className="grid-row" key={index}>
                <div className="grid-item header dark cell" style={{flex: '1 1 0px'}}>
                  {index} occupants
                </div>
                <div className="grid-item utility-cell light" style={{flex: '1 1 0px'}}>
                  <EditableInput
                    placeholder='0'
                    value={tenant}
                    onChange={(e) => updateTenant(index, e.target.value)}
                    inputProps={{maxLength: 2}}
                  >
                    {tenant}
                  </EditableInput>
                </div>
              </div>
            ))}
            <div style={{position: 'relative'}}>
              <div className="grid-item header dark bold cell">
                Common Area Deduction
              </div>
              <div
                data-tut="third-selector"
                style={{
                  width: "1076px",
                  height: "23px",
                  position: "absolute",
                  top: "10px",
                  marginLeft: "10px",
                }}
              ></div>
            </div>
            <div style={{position: 'relative'}}>
              <div className="grid-item header dark cell goodwill-deduction">
                Goodwill Deduction
              </div>
              <div
                data-tut="fourth-selector"
                style={{
                  width: "1076px",
                  height: "23px",
                  position: "absolute",
                  top: "10px",
                  marginLeft: "10px",
                }}
              ></div>
            </div>
            <div>
              <div className="grid-item header dark allocated-tenant-portion cell">
                Allocated tenant portion
              </div>
            </div>
          </div>

          {Object.keys(utilities).map((utility, index) => {
            if (typeof utilities[utility] !== "undefined") {
              return (
                <div
                  className="grid-column light grid-column-utilities right-indent"
                  key={index}
                >
                  {!utilities[utility].isEnabled && (
                    <div className={classes.disabledColumn}></div>
                  )}
                  <UtilityButton
                    hoverItemTitle={utilities[utility].title}
                    onClick={() => updateUtilities(index, utilities[utility].title)}
                    value={utilities[utility].title}
                    isEnabled={utilities[utility].isEnabled}
                  >
                    {utilityIconArray[index]}
                  </UtilityButton>
                  <div className="grid-item utility-cell" style={{marginTop: '43px'}}>
                    <EditableInput
                      placeholder='0'
                      thousandSeparator
                      showDollarSign
                      value={`${utilities[utility].BTV === 0 ? '' : utilities[utility].BTV}`}
                      onChange={(e) =>
                        updateUtilityCalculations(
                          "BTV",
                          e.target.value,
                          utility
                        )
                      }
                    >
                      {utilities[utility].BTV}
                    </EditableInput>
                  </div>
                  {tenants.map((_, index) => (
                    <div className="grid-item dark utility-cell" key={index}>
                      {isNaN(utilities[utility].utilityPerTenant[index])
                        ? "$0"
                        : formatter.format(
                            utilities[utility].utilityPerTenant[index]
                          )}
                    </div>
                  ))}
                  <div className="grid-item utility-cell">
                    <EditableInput
                      placeholder={0}
                      defaultValue={utilities[utility].CAD}
                      value={`${utilities[utility].CAD}`}
                      showPercentSign
                      onChange={(e) =>
                        updateUtilityCalculations(
                          "CAD",
                          e.target.value,
                          utility
                        )
                      }
                    >
                      {utilities[utility].CAD}
                    </EditableInput>
                  </div>
                  <div className="grid-item utility-cell goodwill-deduction-number">
                    <EditableInput
                      placeholder={0}
                      defaultValue={utilities[utility].GWD}
                      value={`${utilities[utility].GWD}`}
                      showPercentSign
                      onChange={(e) =>
                        updateUtilityCalculations(
                          "GWD",
                          e.target.value,
                          utility
                        )
                      }
                    >
                      {utilities[utility].GWD}
                    </EditableInput>
                  </div>
                  <div className="grid-item allocated-tenant-portion utility-cell dark bottom-cell">
                    {formatter.format(utilities[utility].ATP)}
                  </div>
                </div>
              );
            }
            return null;
          })}



          <div
            className="grid-column dark grid-column-utilities right-indent"
            key={1}
          >
            <div className="grid-item header light utility-cell utility-header right-indent estimated-amount">
              Estimated monthly statement
            </div>

            {tenants.map((_, index) => (
              <div className="grid-item dark utility-cell" key={index}>
                {isNaN(averageStatement[index])
                  ? "$0"
                  : formatter.format(averageStatement[index])}
              </div>
            ))}
            <div className="grid-item light utility-cell"></div>
            <div className="grid-item light utility-cell goodwill-deduction-number"></div>
            <div className="grid-item light allocated-tenant-portion utility-cell dark bottom-cell"></div>
          </div>
        </div>
        <div
          data-tut="fifth-selector"
          style={{
            width: "1260px",
            height: "290px",
            position: "absolute",
            marginLeft: "10px",
            marginTop: "20px",
          }}
        ></div>
      </TableContainer>
    </Grid>
  );
}
